// store/slices/filtersSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Station {
  id: string;
  label: string;
}

interface Outlet {
  id: string;
  label: string;
  value: string;
  stations: Station[];
}

interface FiltersState {
  selectedOutlets: Outlet[];
}

const initialState: FiltersState = {
  selectedOutlets: [],
};

const reportFilterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setSelectedOutlets: (state, action: PayloadAction<Outlet[]>) => {
      state.selectedOutlets = action.payload;
    },
    clearFilters: (state) => {
      state.selectedOutlets = [];
    },
  },
});

export const { setSelectedOutlets, clearFilters } = reportFilterSlice.actions;
export default reportFilterSlice.reducer;
